import { serverCall } from 'utils/serverCall';
import {
  initNotificationListRequest,
  setNotificationList,
  appendNotificationList,
  errorNotificationList,
  deleteNotification,
  errorNotificationRequest
} from './action';
import apiEndpoints from 'utils/apiList';
import toast from 'react-hot-toast';

export const fetchNotificationList = ({ page = 1, limit = 10 } = {}) => {
  return async (dispatch) => {
    dispatch(initNotificationListRequest());
    try {
      const result = await serverCall(`${apiEndpoints.NOTIFICATION_LIST}?page=${page}&limit=${limit}`, 'GET', dispatch);
      if (result.success) {
        const payload = {
          data: result.data.data,
          page: result.data.page,
          total: result.data.total,
          totalPage: result.data.totalPage,
          pageSize: result.data.pageSize,
        };
        dispatch(page === 1 ? setNotificationList(payload) : appendNotificationList(payload));
      } else {
        dispatch(errorNotificationList(result.message));
      }
    } catch (error) {
      dispatch(errorNotificationList(error.message));
    }
  };
};

export const deleteNotificationById = (notificationId) => {
  return async (dispatch) => {
    try {
      const result = await serverCall(`${apiEndpoints.NOTIFICATION_DELETE}/update?notif_id=${notificationId}`, 'POST', dispatch);
      if (result.success) {
        dispatch(fetchNotificationList())
        dispatch(deleteNotification(notificationId));
        toast.success('Notification deleted successfully');
      } else {
        toast.error(result.message);
        dispatch(errorNotificationRequest(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorNotificationRequest(error.message));
    }
  };
};
